import { render, staticRenderFns } from "./interface_labels.vue?vue&type=template&id=2d3cf5e9&scoped=true&lang=html"
import script from "./interface_labels.vue?vue&type=script&lang=js"
export * from "./interface_labels.vue?vue&type=script&lang=js"
import style0 from "./interface_labels.vue?vue&type=style&index=0&id=2d3cf5e9&prod&lang=css"
import style1 from "./interface_labels.vue?vue&type=style&index=1&id=2d3cf5e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3cf5e9",
  null
  
)

export default component.exports